<template>
  <div class="w-full">
    <ValidationObserver v-slot="{  }">
      <form class="bg-white px-8 pt-6 pb-8 mb-4" @submit.prevent="createShipping">
        <div class="mb-4">
          <ValidationProvider name="name" rules="required" v-slot="{ errors }">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="name">Name</label>
            <input
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="username"
              type="text"
              v-model="name"
            />
            <span class="text-sm text-red-500">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
        <div class="mb-4">
          <ValidationProvider name="faktor_post" rules="required" v-slot="{ errors }">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="faktor post">Faktor Post</label>
            <input
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="faktor-post"
              type="text"
              v-model="faktori_post"
            />
            <span class="text-sm text-red-500">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
        <div class="mb-4">
          <ValidationProvider name="zup_mosina" rules="required" v-slot="{ errors }">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="zup mosina">Zup Mosina</label>
            <input
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="zup-mosina"
              type="text"
              v-model="zup_mosina"
            />
            <span class="text-sm text-red-500">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
        <div class="mb-4">
          <ValidationProvider name="letzte_meile" rules="required" v-slot="{ errors }">
            <label
              class="block text-gray-700 text-sm font-bold mb-2"
              for="letzte meile"
            >Letzte Meile</label>
            <input
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="letzte-meile"
              type="text"
              v-model="letzte_meile"
            />
            <span class="text-sm text-red-500">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
        <div class="mb-4">
          <ValidationProvider name="paushall" rules="required" v-slot="{ errors }">
            <label
              class="block text-gray-700 text-sm font-bold mb-2"
              for="paushall"
            >Random(Paushall)</label>
            <input
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="paushall"
              type="text"
              v-model="paushall"
            />
            <span class="text-sm text-red-500">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
        <div class="mb-4">
          <ValidationProvider name="thc_zup" rules="required" v-slot="{ errors }">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="thc zup">Tch Zup</label>
            <input
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="tch zup"
              type="text"
              v-model="thc_zup"
            />
            <span class="text-sm text-red-500">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>

        <div class="flex items-center justify-between">
          <button
            class="bg-teal-400 hover:bg-white hover:text-teal-400 text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            type="submit"
          >Save</button>
          <router-link
            to="/calculator"
            class="inline-block align-baseline font-semibold text-sm text-teal-400 hover:text-teal-300"
          >Back</router-link>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      name: "",
      faktori_post: "",
      zup_mosina: "",
      letzte_meile: "",
      paushall: "",
      thc_zup: ""
    };
  },
  methods: {
    createShipping() {
      axios
        .post(`${process.env.VUE_APP_API}/calculate/services`, {
          name: this.name,
          faktori_post: this.faktori_post,
          zup_mosina: this.zup_mosina,
          letzte_meile: this.letzte_meile,
          paushall: this.paushall,
          thc_zup: this.thc_zup
        })
        .then(() => this.$router.push("/shipping"))
        .catch(error => console.log(error));
    }
  }
};
</script>

<style>
</style>